import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { StyledLink } from "./styles";

export const TooltipContent = () => {
    return (
        <div>
            <Text
                color={colorsPalettes.bluegrey[100]}
                fontVariant="tooltip"
            >
                {translate("si.pages.ai_agent.caption.tooltip")}
            </Text>
            <Text
                color={colorsPalettes.blue[300]}
                fontVariant="tooltip"
            >
                <StyledLink
                    href="https://www.similarweb.com/corp/legal/terms/"
                    target="_blank"
                >
                    {translate("si.pages.ai_agent.caption.tooltip.link")}
                </StyledLink>
            </Text>
        </div>
    );
};
